import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete'
import { MatFormField, MatInput } from '@angular/material/input'
import { FormsModule } from '@angular/forms'
import { A11yModule } from '@angular/cdk/a11y'

@Component({
  selector: 'app-singular-autocomplete',
  standalone: true,
  imports: [MatAutocomplete, MatAutocompleteTrigger, MatInput, MatOption, FormsModule, MatFormField, A11yModule],
  templateUrl: './singular-autocomplete.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './singular-autocomplete.component.scss',
})
export class SingularAutocompleteComponent<T> implements OnInit, AfterViewInit {
  @Input()
  inputName!: string

  @Input()
  idKey!: string

  @Input()
  options!: T[]

  @Input()
  displayAutoCompleteValue!: (value: T) => string

  @Input()
  filter!: (query: string, options: T[]) => T[]

  @Output()
  selectOption = new EventEmitter<T>()

  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger!: MatAutocompleteTrigger

  filteredOptions!: T[]

  text = ''

  ngOnInit(): void {
    this.filteredOptions = this.options
  }

  ngAfterViewInit() {
    setTimeout(() => this.autocompleteTrigger.openPanel())
  }

  _filter(input: HTMLInputElement) {
    this.filteredOptions = this.filter(input.value.toLowerCase(), this.options)
  }

  optionSelected($event: MatAutocompleteSelectedEvent) {
    this.text = ''
    this.selectOption.emit($event.option.value)
  }
}
